import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * DialogMfaSetupComponent lets a logged-in user enable MFA from their profile.
 * It wraps the reusable MfaEnrollComponent WITHOUT a setup token, so the
 * AuthInterceptor attaches the current session JWT to the setup/confirm calls.
 */
@Component({
  selector: 'app-dialog-mfa-setup',
  templateUrl: './dialog-mfa-setup.component.html',
  styleUrl: './dialog-mfa-setup.component.scss',
})
export class DialogMfaSetupComponent {
  constructor(public dialogRef: MatDialogRef<DialogMfaSetupComponent>) {}

  onDone() {
    this.dialogRef.close({ success: true });
  }
}
